import React from 'react';
import { FileSearch, SquarePen, Trash } from 'lucide-react';

/** Qawaem ERP row action colors — view copper · edit forest · delete red */
const ACTION_COLORS = {
  view: 'text-[#a67c3d] hover:text-[#8f6634] hover:bg-[#a67c3d]/12',
  edit: 'text-[#5a855a] hover:text-[#4a704a] hover:bg-[#6e9b6e]/15',
  delete: 'text-red-600 hover:text-red-700 hover:bg-red-500/10',
};

/**
 * Standard row actions for Qawaem ERP list tables (view · edit · delete).
 * Uses distinct icons from legacy Eye / Edit / Trash2 patterns.
 */
export default function QawaemErpRowActions({
  onView,
  onEdit,
  onDelete,
  viewTitle,
  editTitle,
  deleteTitle,
  size = 16,
  compact = false,
  className = '',
}) {
  const pad = compact ? 'p-1.5' : 'p-2';
  const gap = compact ? 'gap-1' : 'gap-2';

  return (
    <div className={`flex items-center justify-center ${gap} ${className}`}>
      {onView ? (
        <button
          type="button"
          onClick={onView}
          className={`${pad} rounded-lg transition-colors ${ACTION_COLORS.view}`}
          title={viewTitle}
        >
          <FileSearch size={size} strokeWidth={2} />
        </button>
      ) : null}
      {onEdit ? (
        <button
          type="button"
          onClick={onEdit}
          className={`${pad} rounded-lg transition-colors ${ACTION_COLORS.edit}`}
          title={editTitle}
        >
          <SquarePen size={size} strokeWidth={2} />
        </button>
      ) : null}
      {onDelete ? (
        <button
          type="button"
          onClick={onDelete}
          className={`${pad} rounded-lg transition-colors ${ACTION_COLORS.delete}`}
          title={deleteTitle}
        >
          <Trash size={size} strokeWidth={2} />
        </button>
      ) : null}
    </div>
  );
}
